module.exports = __webpack_public_path__ + "img/12.a76ed346.jpg";